<template lang="pug">
pr-wrapper.channel-program.overflow-hidden(
  v-show="program_",
  :bg="background ? '' : 'transparent'",
  :bgo="background ? '1' : '.5'",
  :class="{ background }"
)
  pr-text.d-flex.align-items-center.mb-1(ellipsis, size="small", v-if="humanize && program_.title")
    moment.text-muted(humanize, format="date", :value="program_.start", live)
    pr-badge.ml-2(v-show="program_.next") {{ $t("Next Program") }}
    pr-badge.ml-2.bg-success.text-white(v-show="program_.current") {{ $t("Now") }}
  pr-text(ellipsis, :muted="muted", :weight="humanize ? 'bold' : 'normal'") {{ program_.title }}
  .program-detail.text-muted.mt-1(v-if="hasDetail_")
    moment.text-nowrap.mr-2(format="hh:mm A", date, :value="program_.start", v-show="time_")
    progress-bar.flex-grow-1.border(:value="epgProgressValue", v-show="progress_")
    pr-text(v-show="!progress_") -
    moment.text-nowrap.ml-2(format="hh:mm A", date, :value="program_.end", v-show="time_")
</template>

<script>
export default {
  name: "channel-program",
  props: ["current", "next", "data", "time", "progress", "background", "humanize", "muted"],
  computed: {
    time_() {
      return _$.true(this.time)
    },
    progress_() {
      return _$.true(this.progress)
    },
    hasDetail_() {
      return (this.time_ || this.progress_) && this.program_.start
    },
    program_() {
      return this.current?.epg?.current || this.next?.epg?.current || this.data || {}
    },
    epgProgressValue() {
      if (!this.hasDetail_) return 0

      const end = this.$moment(this.program_.end),
        start = this.$moment(this.program_.start),
        now = this.$moment()

      const totalDuration = end.diff(start, "minute")
      const leftDuration = end.diff(now, "minute")
      const diff = 100 - (100 * leftDuration) / totalDuration
      return diff
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-program {
  display: flex;
  flex-direction: column;

  .program-detail {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
}
</style>
